import { useState } from "react";
import { PercentageType } from "../../../../../constants/percentageType";
import { ICreateSubStep, ISubStepData } from "../../../../../models/freshman/subStep"
import Joi from "joi";
import { validateFields } from "../../../../../helper/joi-validation";
import { alertConstants, getAlertData } from "../../../../../helper/sweet-alert";
import FloatingLabelTextInput from "../../../../../common-components/floatingtextinput";
import { connect } from "react-redux";
import { createSubStep } from "../../../../../action/freshman/subStepActionCreator";
import SweetAlert from "react-bootstrap-sweetalert";
import LoaderSpinner from "../../../../../common-components/loader";

const SubStepCreate = (props: ICreateSubStep) => {

    const { createSubStep, setShowCreate, getAllSubSteps } = props

    const initialData: ISubStepData = {
        id: null,
        name: "",
        description: "",
        url: "",
        isActive: true,
        percentageType: PercentageType.Api,
        isAdminApprovalRequired: true
    };

    const [data, setData] = useState(initialData);
    const [errors, setErrors] = useState<any>(undefined);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [alertType, setAlertType] = useState<any>("success");
    const [alertTitle, setAlertTitle] = useState<string>("Default");
    const [showAlertCancel, setShowAlertCancel] = useState<boolean>(false);
    const [isDisabled, setIsDisabled] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const onChange = (
        event:
            | React.ChangeEvent<HTMLInputElement>
            | React.ChangeEvent<HTMLSelectElement>
            | React.ChangeEvent<HTMLSelectElement>
            | React.ChangeEvent<HTMLSelectElement>
            | React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        errors && delete errors[event.target.name];

        const _data = { ...data, [event.target.name]: event.target.value };
        if (event.target.type === "radio") {
            if (event.target.id === "isEmail") {
                _data.isAdminApprovalRequired = true;
            } else if (event.target.id === "isNotEmail") {
                _data.isAdminApprovalRequired = false;
            }
            if (event.target.id === "api") {
                _data.percentageType = PercentageType.Api;
            } else if (event.target.id === "manual") {
                _data.percentageType = PercentageType.Manual;
            }
        }
        setData(_data);
    };

    const urlRegex = /^https?:\/\/([a-z0-9]{2,}(-[a-z0-9]{2,})*\.)+[a-z0-9]{2,6}(\/[a-z0-9#?=&%\/\-_\.]*)?$/i;

    const schema = Joi.object().keys({
        name: Joi.string().required().label("Name is required"),
        url: Joi.string().allow(null, '').regex(urlRegex).label("Enter Valid URL"),
    });

    const onSave = async () => {
        const cleanedData = {
            ...data,
            name: data.name.trim().replace(/\s+/g, ' '),
        };
        const validationErrors = validateFields(cleanedData, schema);
        if (validationErrors === undefined) {
            setLoading(true)
            setIsDisabled(true)
            try {
                await createSubStep(cleanedData, setAlert);
            } finally {
                setLoading(false)
                setIsDisabled(false)
            }
        } else {
            setErrors(validationErrors);
        }
    };

    const setAlert = (type: string) => {
        let alertData = getAlertData(type);
        if (alertData) {
            setShowAlert(true);
            setAlertType(alertData.type);
            setAlertTitle(alertData.title);
        }
    };

    const onConfirm = () => {
        if (alertType === alertConstants.error) {
            setShowAlert(false);
        } else {
            getAllSubSteps();
            setShowCreate(false);
        }
    };

    const onCancel = async () => {
        setShowAlertCancel(true);
        setAlert(alertConstants.cancelCheck);
    };


    return (
        <>
            <div className="modal-header">
                <h1 className="modal-title fs-5" id="addnewbuttonsLabel">Add Sub Task</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setShowCreate(false)}></button>
            </div>
            <div className="modal-body">
                <div className="row">
                    <div className="col-lg-6 form-group">
                        <FloatingLabelTextInput
                            label={"Name "}
                            onChange={onChange}
                            isMandatory={true}
                            value={data.name}
                            name={"name"}
                            maxLength={50}
                        />
                        {errors?.name && <div className="text-danger">{errors.name}</div>}
                    </div>
                    <div className="col-lg-6 form-group">
                        <FloatingLabelTextInput
                            label={"URL "}
                            onChange={onChange}
                            isMandatory={false}
                            value={data.url}
                            name={"url"}
                            maxLength={500}
                        />
                        {errors?.url && <div className="text-danger">{errors.url}</div>}
                    </div>
                    <div className="col-lg-12 form-group">
                        <label className="profile_details_text">
                            Description
                        </label>
                        <textarea
                            name="description"
                            value={data.description}
                            onChange={onChange}
                            maxLength={1000}
                        >
                        </textarea>
                        {errors?.description && <div className="text-danger">{errors.description}</div>}
                    </div>
                    <div className="col-lg-6 form-group">
                        <label className="profile_details_text">Mode</label>
                        <div className="d-flex gap-3">
                            <div className="form-checkbox">
                                <input type="radio" id="api" name="percentageType" checked={data.percentageType === PercentageType.Api} onChange={onChange} />
                                <label htmlFor="api"> API</label>
                            </div>
                            <div className="form-checkbox">
                                <input type="radio" id="manual" name="percentageType" checked={data.percentageType === PercentageType.Manual} onChange={onChange} />
                                <label htmlFor="manual"> Manual</label>
                            </div>
                        </div>
                    </div>
                    {data.percentageType == PercentageType.Manual && (
                        <div className="col-lg-6 form-group">
                            <label className="profile_details_text">Email Validation</label>
                            <div className="d-flex gap-3">
                                <div className="form-checkbox">
                                    <input id="isEmail" type="radio" name="isEmail" checked={data.isAdminApprovalRequired} onChange={onChange} />
                                    <label htmlFor="isEmail"> Yes</label>
                                </div>
                                <div className="form-checkbox">
                                    <input id="isNotEmail" type="radio" name="isEmail" checked={!data.isAdminApprovalRequired} onChange={onChange} />
                                    <label htmlFor="isNotEmail"> No</label>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="modal-footer">
                <button type="button" className="btn btn-primary" onClick={onSave}
                    disabled={isDisabled}>Save</button>
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => setShowCreate(false)}
                    disabled={isDisabled}>Close</button>
            </div>

            <SweetAlert
                show={showAlert}
                success={false}
                type={alertType}
                title={alertTitle}
                onConfirm={() => onConfirm()}
                showCancel={showAlertCancel}
                onCancel={() => {
                    setShowAlert(false);
                    setShowAlertCancel(false);
                }}
                cancelBtnText={"No"}
                confirmBtnText={showAlertCancel ? "Yes" : "Ok"}
            ></SweetAlert>
            {loading && <LoaderSpinner />}
        </>
    )
}

const mapDispatchToProps = {
    createSubStep: (data: any, callBack: Function) => createSubStep(data, callBack),
};

export default connect(null, mapDispatchToProps)(SubStepCreate);